export default "__VITE_ASSET__JfZyVIWW__"